import { render, staticRenderFns } from "./Departamentos.view.vue?vue&type=template&id=1656c416"
import script from "./Departamentos.view.vue?vue&type=script&lang=js"
export * from "./Departamentos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports